module.exports = __webpack_public_path__ + "img/厦门诚信促进会会员_00.77899f89.jpg";